import { cn } from '../../lib/cn';

type Props = {
  stages?: string[];
  currentStage?: string;
};

export function LifecycleStageTracker({ stages = [], currentStage = 'Review' }: Props) {
  const currentIdx = stages.indexOf(currentStage);

  return (
    <div className="overflow-x-auto pb-2">
      <div className="flex min-w-max gap-1">
        {stages.map((stage, i) => (
          <div key={stage} className="flex items-center gap-1">
            <div
              className={cn(
                'rounded-lg px-2 py-1 text-xs font-medium whitespace-nowrap',
                i < currentIdx && 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300',
                i === currentIdx && 'bg-brand-600 text-white',
                i > currentIdx && 'border border-slate-200 text-slate-400 dark:border-slate-700',
              )}
            >
              {stage}
            </div>
            {i < stages.length - 1 && <span className="text-slate-300">→</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
